import React, { useState } from "react";
import { Modal, Button } from "semantic-ui-react";
import { producaov2 as api, local } from "../../../../services/apis";
import swal from "sweetalert";
import AlunosSelector from "../../AlunosSelector";
import CursosSelector from "../../CursosSelector";

export default function ModalSubmit({ open, handleClose, idPlano }) {
  const [aluno, setAluno] = useState(null);
  const [curso, setCurso] = useState(null);

  const handleSubmit = async () => {
    await api
      .post("/pagarme/criar_assinatura", {
        id_plano: idPlano,
        id_curso: curso,
        id_pessoa: aluno,
      })
      .then(res => {
        return swal({
          title: "Link de pagamento",
          text: `voitto.com.br/inscricao/${curso}`,
          buttons: {
            copy: "Copiar link",
          },
        }).then(() => {
          navigator.clipboard.writeText(`voitto.com.br/inscricao/${curso}`);
          handleClose(false);
        });
      })
      .catch(err => {
        swal("Erro ao criar plano!", "error");
      });
  };

  return (
    <Modal size={"small"} open={open} onClose={() => handleClose(false)}>
      <Modal.Header>Cria plano para aluno</Modal.Header>
      <Modal.Content>
        <Modal.Description>Id do plano {idPlano}</Modal.Description>
        <AlunosSelector handleChange={setAluno} />

        <CursosSelector handleChange={setCurso} />
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" color="orange" onClick={() => handleSubmit()}>
          Cadastrar
        </Button>
        <Button onClick={() => handleClose(false)}>Cancelar</Button>
      </Modal.Actions>
    </Modal>
  );
}
